import { useCourseStore } from '@/infrastructure/store/courseStore';

export const useCourse = () => {
  const store = useCourseStore();
  return {
    currentCourse: store.currentCourse,
    currentSubcategory: store.currentSubcategory,
    isLoading: store.isLoading,
    error: store.error,
    fetchCourseAndSubcategory: store.fetchCourseAndSubcategory,
    clearCourse: store.clearCourse,
  };
};
